var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.isVisible)?_c('p',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.countdown.hours)+":"+_vm._s(_vm.countdown.minutes)+":"+_vm._s(_vm.countdown.seconds))])]):_c('p',{staticClass:"text-center"},[_c('strong',[_vm._v("-")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }